module.exports = __webpack_public_path__ + "static/img/puji22.0de7ffae.png";